import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#292929",
      paper: "#333333"
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#AAAAAA"
    },
    primary: {
      main: "#FECD07"
    },
    secondary: {
      main: "#FFFFFF"
    }
  }
});
